module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAMElEQVRIx2MoXXWbRohh1OhRo/EbvevqWxohhnCaAYahCWgYIDSMxtEsM2r0QBkNAG/2EKEtWLomAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/bw.png
// module id = 248
// module chunks = 0